<script lang='ts'>

    /* IMPORTS --------------------------------------------------------------------------------- */

    import {
        Heading,
        Paragraph,
    } from '@smatch/cassiopeia-web-components';

    // COMPONENTS
    import AuctionReservedBidForm from 'src/app/routes/auctions/pages/auction-item/components/AuctionReservedBidForm.svelte';

    // TYPES
    import type { Auction } from 'src/app/types';

    /* EXPORTS ----------------------------------------------------------------------------------- */

    export let auction: Auction;

</script>

    <Heading size='md'>
        Deal Reserved
    </Heading>
    <Paragraph>
        Another buyer has secured this deal. We will be in touch if availability changes.
    </Paragraph>
    {#if auction.brands !== undefined}
        <Paragraph>
            We are working to source additional stock from the Brand { auction.brands[0].name }.
        </Paragraph>
    {/if}
    <Paragraph>
        If you want to be the first to know about it, join our waiting list.
    </Paragraph>

    <AuctionReservedBidForm
        on:save
        { auction }
        css = 'w-full mt-4'
    />